import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatDialogConfig, MatTab} from '@angular/material';
import {Observable} from 'rxjs';
import {AdminListService} from '../shared/services/admin-list.service';
import {PersonDialogueComponent} from './person-dialogue/person-dialogue.component';
import {AdminUsersService} from '../shared/services/admin-users.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  links = ['First', 'Second', 'Third'];
  activeLink = this.links[0];
  background = 'red';

  showBtn = false;
  selectedUser;
  users$: Observable<any[]>;
  @ViewChild('users') users: ElementRef<MatTab>;
  @ViewChild('lists') lists: ElementRef<MatTab>;
  constructor(public adminService: AdminListService,
              public userService: AdminUsersService,
              private dialog: MatDialog) { }

  ngOnInit() {
    this.users$ = this.adminService.getPeople();
  }
  editPerson(person) {
    const dialogConfig = new MatDialogConfig();
    console.log('Clicked')
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = person;
    const dialogRef = this.dialog.open(PersonDialogueComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(resp => {
      if (!resp) {
        return;
      }
      console.log(resp.data);
      this.userService.updateUser(resp.personId, resp.data)
    });
  }
  onSelect(user) {
    this.selectedUser = user;
  }
  onCreate() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = '';
    const dialogRef = this.dialog.open(PersonDialogueComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog is Closed - do somethingh else');
      // or navigate somewhere
    });
  }
  onDelete(id) {
    this.adminService.deleteUser(id);
  }
}
